import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { LayoutSplashScreen } from "../../components/SplashScreen";

const LoginPage = lazy(() => import("./LoginPage"));
const EsqueceuSenhaPage = lazy(() => import("./EsqueceuSenhaPage"));
const RecuperarSenhaPage = lazy(() => import("./RecuperarSenhaPage"));
const RegisterPage = lazy(() => import("./RegisterPage"));

export default function AuthPage() {
	return (
		<Suspense fallback={<LayoutSplashScreen />}>
			<Switch>
				<Redirect exact from="/" to="/login" />
				<Route path="/login" component={LoginPage} />
				<Route path="/register" component={RegisterPage} />
				<Route path="/esqueceu-senha" component={EsqueceuSenhaPage} />
				<Route path="/recuperar-senha" component={RecuperarSenhaPage} />

				<Redirect to="/login" />
			</Switch>
		</Suspense>
	);
}
